var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(!_vm.formalitySchema)?_c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"size":70,"width":7,"indeterminate":""}})],1):_c('dynamic-form',{ref:"form",attrs:{"options":{
      company: {exclude: true},
      statusLabels: {exclude: true},
      functionName: {exclude: true}
    },"schema":_vm.formalitySchema,"value":_vm.item},on:{"submit":function($event){return _vm.submitForm($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }